import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { ServiceResult } from '../types/common/ServiceResult';
import type { WarrantyViewModel, WarrantyCreateModel, WarrantyUpdateModel } from '../types/warranty';
import { apiClient } from '../client/client';

export class WarrantyService {
  private static readonly BASE = '/api/warranty';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(): Promise<ServiceResultT<WarrantyViewModel[]>> {
    const { data } = await this.client.get<ServiceResultT<WarrantyViewModel[]>>(
      WarrantyService.BASE
    );
    return data;
  }

  async getById(id: number | string): Promise<ServiceResultT<WarrantyViewModel>> {
    const { data } = await this.client.get<ServiceResultT<WarrantyViewModel>>(
      `${WarrantyService.BASE}/${id}`
    );
    return data;
  }

  async create(payload: WarrantyCreateModel): Promise<ServiceResultT<WarrantyViewModel>> {
    const { data } = await this.client.post<ServiceResultT<WarrantyViewModel>>(
      WarrantyService.BASE,
      payload
    );
    return data;
  }

  async update(id: number | string, payload: WarrantyUpdateModel): Promise<ServiceResultT<WarrantyViewModel>> {
    const { data } = await this.client.put<ServiceResultT<WarrantyViewModel>>(
      `${WarrantyService.BASE}/${id}`,
      payload
    );
    return data;
  }

  async delete(id: number | string): Promise<ServiceResult> {
    const { data } = await this.client.delete<ServiceResult>(`${WarrantyService.BASE}/${id}`);
    return data;
  }
}

export const warrantyService = new WarrantyService();
